import { Component,  EventEmitter,  Input, Output } from '@angular/core';
import { MAX_ENTITY_STARS } from 'globals/helpers/constants';
import { IconComponent } from '../icon/icon.component';
import { CommonModule } from '@angular/common';
import { NumberToArrayPipe } from 'src/app/services/pipes/numberToArray.pipe';

@Component({
    selector: 'stars',
    template: `
<icon *ngFor="let star of maxStars | numberToArray; index as s;"
  [matIcon]="s < stars ? 'star' : 'star_border'"
  [i12]="tiny"
  (click)="s + 1 === stars ? setStars.emit(0) : setStars.emit(s + 1)"
></icon>
`,
    styleUrls: ['stars.scss'],
    standalone: true,
    imports: [IconComponent, CommonModule, NumberToArrayPipe]
})
export class StarsComponent {
  @Input() maxStars = MAX_ENTITY_STARS
  @Input() stars = 0
  @Input() tiny = false
  starArray = []
  @Output() setStars: EventEmitter<number> = new EventEmitter()
}

